import {Component} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {BsaInvoiceLinksXBVO, InvoiceLinkXBVO, MenuPlanLinkXBVO} from "../model/xbvo.model";
import {RestClient} from "../rest-client.service";
import {DateUtilsBs} from "../base/utils/dateUtilsBs";
import {DomSanitizer} from '@angular/platform-browser';

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-invoices>',
    template: `
        <skitbs-template [title]="v('menu_invoices')">
            <p-table [value]="modelLiknks" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Datum</th>
                        <th>Monat</th>
                        <th>Rechnung-Nr.</th>
                        <th>PDF</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pLink>
                    <tr>
                        <td class="TexAlCenter">{{dateFormat(pLink.invoiceDate)}}</td>
                        <td class="TexAlCenter">{{dateFormat(pLink.invoiceDate, 'MMMM')}}</td>
                        <td class="TexAlCenter">{{pLink.invoiceNr}}</td>
                        <td class="TexAlCenter"><a (click)="onPdfDownload(pLink)"><i class="pi pi-download"></i></a></td>
                    </tr>
                </ng-template>
            </p-table>
        </skitbs-template>
    `
})
export class InvoicesComponent extends BaseComponent {

    modelLiknks: InvoiceLinkXBVO[] = [];

    constructor(private restClient: RestClient) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        let pToday = new Date();
        let pStartDate = DateUtilsBs.addDays(pToday, -7);
        this.restClient
            .invoiceLinks()
            .subscribe(aXBVO => this.modelLiknks = aXBVO.link);
    }

    /**
     * Action.
     * @param aLink
     * @private
     */
    public onPdfDownload(aLink: InvoiceLinkXBVO) {
        this.restClient
            .invoicePDF(aLink.invoiceNr)
            .subscribe(aBlob => {
                let pFilename = "Rechnung_" + aLink.invoiceNr + ".pdf";
                this.fileDownload(aBlob, pFilename);
            });
    }

    /**
     * Formats.
     * @param aLink
     * @private
     */
    private formatDateRange(aLink: MenuPlanLinkXBVO): string {
        let pWeekStartEndDate = DateUtilsBs.getWeekStartEndDate(aLink.year, aLink.week);
        return DateUtilsBs.format(pWeekStartEndDate[0], 'dd.MM') + " - " + DateUtilsBs.format(pWeekStartEndDate[1], 'dd.MM');
    }
}
